<template>
  <div>
    <gmap-map :center="center" :zoom="7" style="width:100%;  height: 400px;">
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :clickable="true"
        :draggable="true"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  props: ["mapArea"],
  data() {
    return {
      center: { lat: "", lng: "" },
      markers: [
        {
          label: "",
          position: { lat: "", lng: "" },
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.lati();
      this.marke();
    }, 500);
  },
  methods: {
    lati: function () {
      this.center = {
        lat: parseFloat(this.mapArea.Latitude),
        lng: parseFloat(this.mapArea.Longitude),
      };
    },
    marke: function () {
      this.markers = [
        {
          label: this.mapArea.Location,
          position: {
            lat: parseFloat(this.mapArea.Latitude),
            lng: parseFloat(this.mapArea.Longitude),
          },
        },
      ];
    },
  },
};
</script>